import { Button, Typography } from "@mui/material";
import { analyticsTrack } from "app/analytics/track";
import Guidelines from "components/Guidelines";
import PageWrapper from "components/PageWrapper";
import { selectUserProfile } from "features/auth/auth";
import { acceptCommunityCommitments } from "features/member/profile/memberProfileSlice";
import LoadingPage from "features/pages/LoadingPage";
import { useLogEventOnLoad } from "hooks/useLogEventOnLoad";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FixedCTAContainer } from "features/signup/FixedCTAContainer";
import { SetupProgressBar } from "features/setup/SetupProgressBar";
import { BRAND_NAME } from "@app/shared/constants";

export const SignupCommitmentsStep = (props: { analyticsPrefix: string }) => {
    const [accepting, setAccepting] = useState(false);
    const userProfile = useSelector(selectUserProfile);
    const dispatch = useDispatch();

    useLogEventOnLoad(`${props.analyticsPrefix}.commitments.load`);

    if (!userProfile) {
        return <LoadingPage />;
    }

    const onAccept = async () => {
        analyticsTrack(`${props.analyticsPrefix}.commitments.submit`);
        setAccepting(true);
        dispatch(
            acceptCommunityCommitments({
                id: userProfile.id,
            }),
        );
    };

    const renderAgreementButton = () => (
        <FixedCTAContainer>
            <Button
                data-testid="continueButton"
                variant="primary"
                disabled={accepting}
                onClick={() => onAccept()}
            >
                I agree to all commitments
            </Button>
        </FixedCTAContainer>
    );

    return (
        <>
            <SetupProgressBar currentStep={0} />
            <PageWrapper>
                <Typography variant="h2">{BRAND_NAME} is a safe space.</Typography>

                <Guidelines />
                {renderAgreementButton()}
            </PageWrapper>
        </>
    );
};
